// arabic
export const validationMessages = {
  email: {
    valid: "ادخل البريد الالكترنى بشكل صحيح",
  },
  password: {
    short: "كلمة المرور قصيرة",
    long: "كلمة المرور طويلة",
  },
  password_confirmation: {
    match: "يجب ان تكون كلمات المرور متطابقة",
  },
  field: {
    required: "هذا الحقل مطلوب",
  },
  img: {
    too_big: "حجم الصورة كبير ",
    not_allowed: "امتداد الصورة يجب ان يكون jpg , png",
    required: "الصورة مطلوبة",
  },
  url: {
    valid_url: "ادخل رابط صحيح",
  },
  title: {
    too_short: "العنوان قصير جدا",
    required: "العنوان مطلوب",
  },
  phone: {
    valid: "ادخل رقم هاتف صحيح",
  },
  body: {
    too_short: "المحتوي قصير جدا",
  },
  should: {
    number: "يجب ان يكون رقم",
  },
};
